import { IUser } from "../../common/types";

export enum AppActions {
  SET_USER = "SET_USER",
  CLEAR_USER = "CLEAR_USER",
}

export interface ISetUser {
  type: AppActions.SET_USER;
  user: IUser;
}

export interface IClearUser {
  type: AppActions.CLEAR_USER;
}

export function setUser(user: IUser): ISetUser {
  return {
    type: AppActions.SET_USER,
    user,
  };
}

export function clearUser(): IClearUser {
  return {
    type: AppActions.CLEAR_USER,
  };
}

export type AppAction = ISetUser | IClearUser;
